module.exports = __webpack_public_path__ + "static/header-2c521d5dd709d31f8e0d0626972acba4.png";